import { Flex, Text, useMantineTheme } from "@mantine/core";
import { Checkbox } from "../../../../components";
import { EOrderStatus, IQueryPosition } from "../../../../interfaces/IQuery";
import { useMediaQuery } from "@mantine/hooks";
import { useTranslation } from "react-i18next";

interface IProps {
  query: IQueryPosition;
  setQuery: React.Dispatch<React.SetStateAction<IQueryPosition>>;
}

const optionsFilters = [
  { label: "operacoes.mock.all", value: EOrderStatus.ALL },
  { label: "operacoes.mock.filled", value: EOrderStatus.FILLED },
  { label: "operacoes.mock.rejected", value: EOrderStatus.REJECTED },
  // { label: 'operacoes.mock.canceled', value: EOrderStatus.CANCELED },
  {
    label: "operacoes.mock.partially_executed",
    value: EOrderStatus.PARTIALLY_FILLED,
  },
];

const CustomSegmentedControl = ({ query, setQuery }: IProps) => {
  const theme = useMantineTheme();
  const currentValues = query.order_status || [EOrderStatus.ALL];
  const isLargerThan780 = useMediaQuery("(min-width: 780px)");
  const { t } = useTranslation();
  const handleClick = (value: EOrderStatus) => {
    let updatedValues: EOrderStatus[] = [];

    if (value === EOrderStatus.ALL) {
      updatedValues = [EOrderStatus.ALL];
    } else {
      if (currentValues.includes(value)) {
        updatedValues = currentValues.filter((v) => v !== value);
      } else {
        updatedValues = [
          ...currentValues.filter((v) => v !== EOrderStatus.ALL),
          value,
        ];
      }

      const allValuesSelected = optionsFilters
        .filter((option) => option.value !== EOrderStatus.ALL)
        .every((option) => updatedValues.includes(option.value));

      const noneSelected = updatedValues.length === 0;

      if (allValuesSelected || noneSelected) {
        updatedValues = [EOrderStatus.ALL];
      }
    }

    // Atualizar o estado usando setQuery
    setQuery((prevQuery) => ({
      ...prevQuery,
      order_status: updatedValues,
    }));
  };

  return (
    <Flex w={"100%"}>
      <Flex
        align="center"
        justify={"center"}
        wrap={{ base: "wrap", 780: "nowrap" }}
        miw={{ base: "100%", 780: "auto" }}
        gap="8px"
        style={{
          borderRadius: "50px",
          overflow: isLargerThan780 ? "hidden" : "visible",
          padding: "4px",
          backgroundColor: theme.colors.primaryOpacity[1],
        }}
      >
        {optionsFilters.map((option) => (
          <Flex
            key={option.value}
            direction="row"
            align="center"
            gap="4px"
            onClick={() => handleClick(option.value)}
            sx={{
              cursor: "pointer",
              padding: "8px 16px",
              borderRadius: "50px",
              backgroundColor: currentValues?.includes(option.value)
                ? theme.colors.primary[2]
                : "transparent",
              color: currentValues?.includes(option.value)
                ? "#ffffff"
                : "#000000",
              transition: "background-color 0.3s ease",
            }}
          >
            <Text
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                fontFamily: "Barlow",
                color: currentValues?.includes(option.value)
                  ? "#FFFFFF"
                  : theme.colors.primary[0],
              }}
            >
              {t(option.label)}
            </Text>
            <Checkbox
              checked={currentValues?.includes(option.value)}
              onChange={() => handleClick(option.value)}
              style={{ cursor: "pointer" }}
            />
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
};

export default CustomSegmentedControl;
